<template>
  <div class="app">
    <div class="app-mian" ref="apptop">
      <router-view></router-view>
    </div>
    <router-view name="footer" class="app-footer"></router-view>
  </div>
</template>
<script>
export default {
  watch: {
    $route: function (to, from) {
      this.$refs.apptop.scrollTop = 0;
    },
  },
  mounted() {
    window.sessionStorage.removeItem("show");
  },
};
</script>
<style>
.app {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}
.app-mian {
  flex: 1 !important;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.app-footer {
  position: fixed;
  bottom: 0;
  /* height: 1rem; */
  width: 100%;
}
@supports (bottom: env(safe-area-inset-bottom)) {
  .app-footer {
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
